import { NextPage } from "next";

import withAuthRedirect from "hooks/withAuthRedirect";
import { CustomAppPage } from "src/types/types";

/**
 * Require the user to be authenticated in order to render the component.
 * If the user isn't authenticated, forward to the Homepage, open LoginModal
 * and redirect to the original page on successful login.
 */
export default function withAuth<P extends JSX.IntrinsicAttributes>(
  WrappedComponent: CustomAppPage<P>,
  hasHiddenFooter?: boolean | undefined,
): NextPage<P> {
  return withAuthRedirect({
    WrappedComponent,
    expectedAuth: true,
    hasHiddenFooter,
  });
}
